import useWindowSize from '../../../../hooks/useWindowSize';
import Locations from '../../../Locations';
import ScrollToTopButton from '../../../ScrollToTopButton';
import AboutButton from '../AboutButton';
import styles from './styles.module.css';
import { useNavigate } from 'react-router-dom';

const DesktopFooter = ({
  paddingTop,
  paddingLeft,
  paddingRight,
  paddingBottom,
}: {
  paddingTop?: number;
  paddingBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
}) => {
  const { width: screenWidth } = useWindowSize();
  const navigate = useNavigate();

  const handleContactClick = () => {
    window.location.href = 'mailto:info@go-bees.com';
  };

  return (
    <div
      className={styles.Container}
      style={{
        paddingTop: paddingTop ? paddingTop : 100,
        paddingBottom: paddingBottom ? paddingBottom : 15,
        paddingLeft: paddingLeft ? paddingLeft : 0,
        paddingRight: paddingRight ? paddingRight : 0,
      }}
    >
      <div className={styles.FooterContentDiv}>
        <div className={styles.BeesLogoDiv}>
          <img
            className={styles.BeesLogoImg}
            src={'/assets/icons/bees_logo.svg'}
            alt={'bees'}
          />
          <p className={styles.BeesLogoText}>THE REAL ESTATE PLATFORM</p>
        </div>
        <div className={styles.ContentDiv}>
          <div className={styles.RouteDivContainer}>
            <div className={styles.RouteDiv}>
              <h2 className={styles.RouteDivTitle}>Company</h2>
              <div className={styles.RouteButtonsDiv}>
                <div>
                  <AboutButton />
                </div>
                <div>
                  <button
                    className={styles.RouteButton}
                    onClick={handleContactClick}
                  >
                    Contact
                  </button>
                </div>
                <div>
                  <button
                    className={styles.RouteButton}
                    onClick={() => {
                      navigate('/privacy_policy');
                    }}
                  >
                    Privacy Policy
                  </button>
                </div>
              </div>
            </div>
          </div>

          {screenWidth > 1040 && (
            <div className={styles.RouteDiv}>
              <h2
                className={styles.RouteDivTitle}
                style={{ textAlign: 'start', width: '100%' }}
              >
                Locations
              </h2>
              <Locations />
            </div>
          )}

          <ScrollToTopButton />
        </div>
      </div>
      <div className={styles.CopyrightDiv}>
        <p className={styles.CopyrightText}>
          All rights reserved © 2024 | BEES, The Real Estate Platform.
        </p>
      </div>
    </div>
  );
};

export default DesktopFooter;
